
import React from 'react';
import NoticePage from '../components/Notice';
import Footer from '../components/Footer';


function Notice() {
  return (
    <>
        <NoticePage />
        <Footer />
    </>
  );
}


export default Notice;
